import React from "react";
import Slider from './Slider';

function classNames(...args) {
  return args.filter(i => i).join(' ');
}

export default class NewRotatingBannerSection extends React.Component {
  getSafeText(rawText) {
    if (typeof rawText !== 'string') return '';
    return rawText.replace(/<[^>]*>/g, '').trim();
  }

  getSafeUrl(rawUrl) {
    if (typeof rawUrl !== 'string' || !rawUrl.trim()) return null;
    try {
      const parsed = new URL(rawUrl, window.location.origin);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
        return null;
      }
      return parsed.toString();
    } catch (e) {
      return null;
    }
  }

  getSafeTarget(target) {
    return target === '_self' ? '_self' : '_blank';
  }

  render() {
    let pages = this.props.pages || [];
    return (
      <div className='pubhub-new-rotating-banner'>
        <div className="pubhub-new-rotating-banner-prev" onClick={this.onPrev}>
        </div>
        <div className="pubhub-new-rotating-banner-next" onClick={this.onNext}>
        </div>
        <Slider ref={dom => this.slider = dom}>
          {
            pages.map((page, index) => {
              return this.renderPage(page, index);
            })
          }
        </Slider>
      </div>
    );
  }

  renderPage(page, key) {
    const className = 'pubhub-new-rotating-banner-page';
    const action = page.action || {};
    const target = this.getSafeTarget(action.target);
    const safeActionHref = this.getSafeUrl(action.href);
    const safeBackgroundUrl = this.getSafeUrl(page.pic);
    const safeTitleText = this.getSafeText(page.title);
    const safeDescriptionText = this.getSafeText(page.description);
    const actions = this.renderActions(page.actions, className);

    return (
      <div key={key} className={className} style={{ backgroundImage: safeBackgroundUrl ? 'url(' + safeBackgroundUrl + ')' : 'none' }}>
        <div className='pubhub-new-rotating-banner-page-content'>
          <div className={className + '-title'}>{safeTitleText}</div>
          <div className={className + '-description'}>{safeDescriptionText}</div>
          {action.label && safeActionHref && <a id={action.id} className={classNames(className + '-action', action.className)} href={safeActionHref} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined}>{action.label}</a>}
          {actions}
        </div>
      </div>
    );
  }

  renderActions(actions, className) {
    if (!actions || actions.length == 0) return null;

    const list = actions.map(action => {
      const target = this.getSafeTarget(action.target);
      const safeHref = this.getSafeUrl(action.href);
      if (!safeHref) return null;
      return (<a id={action.id} className={classNames(className + '-action-item', action.className)} href={safeHref} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined}>{action.label}</a>);
    }).filter(Boolean);

    return (
      <div className={className + '-actions'}>
        {list}
      </div>
    );
  }

  onPrev = () => {
    this.slider.slideRight();
  }

  onNext = () => {
    this.slider.slideLeft();
  }
}
